import "./style.css";
import { formatGBP } from "../../utils/currency";
type ContainerProps = {
  [x: string]: any;
};

const parties = ["Client", "Partner", "Joint"];
const periods = ["Monthly", "Annual"];

const IncomeCalcTable = (props: ContainerProps) => {
  const values = props.IncomeCalculationValues ?? {};
  return (
    <div className="income-calc-wrapper">
      {["Gross", "Net"].map((type) => (
        <table key={type} className="income-calc-table">
          <thead>
            <tr>
              {type === "Gross" && <th rowSpan={2}></th>}
              <th colSpan={parties.length} className="income-calc-title">
                {type}
              </th>
            </tr>
            <tr>
              {parties.map((party) => (
                <th key={party}>{party}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {periods.map((period) => (
              <tr key={period}>
                {type === "Gross" && <th scope="row">{period}</th>}
                {parties.map((party) => (
                  <td key={party}>
                    {formatGBP(values[`${party}${period}${type}Amount`])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ))}
    </div>
  );
};

export default IncomeCalcTable;
